import React from 'react';
import SVG from 'react-inlinesvg';

import Theme from '/app/src/theme';
import {Flex, SVGButton} from '/app/src/component';
import style from './style.css'
import { history } from '/app/src/store';


class QuestionItem extends React.Component {
    constructor(props) {
        super(props);
        this.mouseEnter = this.mouseEnter.bind(this)
        this.mouseLeave = this.mouseLeave.bind(this)

        this.state = {
            hover: false
        }
    }

    mouseEnter() {
        this.setState({hover: true})
    }

    mouseLeave() {
        this.setState({hover: false})
    }

    _renderHover() {
        const {hover} = this.state
        const {questionId, categoryId, visible} = this.props
    
        const visibleIcon = <SVG style={{fill: Theme.colors.blue}} className={style.Icon} src='/images/Visible.svg' cacheGetRequests={true}/>
        const hiddenIcon = <SVG style={{fill: Theme.colors.lightblack}} className={style.Icon} src='/images/Hidden.svg' cacheGetRequests={true}/>
        if (!hover) {
            return (
                <Flex vAlignContent='center' column shrink={0}>
                    <Flex center w='100px'>
                        {visible ? visibleIcon : hiddenIcon}
                    </Flex>
                    <Flex center className={style.LiveText}>
                        {visible && 'Live'}
                    </Flex>
                </Flex>
            )
        } else {
            return (
                <Flex h='100%' w='100px'
                    column shrink={0}
                    center>
                    <SVGButton className={style.OptionsIcon}
                    src='/images/GoToEdit_M.svg'
                    onClick={(e)=>{
                        e.stopPropagation();
                        history.push('/clientChat/faq/helpdesk/category/'+categoryId+'/update/'+questionId);
                        }
                    }
                    color={Theme.colors.black} h='55px' hover='blue'/>
                </Flex>
            )
        }
    }

    render() {
        const {question, onClick, currentItem, questionId, nbrPositive, nbrNegative} = this.props
    
        const posIcon = <SVG style={{fill: Theme.colors.green1}} className={style.Icon} src='/images/emojiSmile2.svg' cacheGetRequests={true}/>
        const negIcon = <SVG style={{fill: Theme.colors.red1}} className={style.Icon} src='/images/emojiUnhappy.svg' cacheGetRequests={true}/>

        let border = {}

        if(currentItem === questionId){
            border = {border: '3px solid #2ea2d2'};
        }
        
        return (
            <Flex onClick={onClick} className={style.QuestionBody}
                onMouseEnter={this.mouseEnter}
                onMouseLeave={this.mouseLeave}
                bg='grey1' shrink={0}
                style={border}
                >
                <Flex vAlignContent='center' grow>
                    <Flex className={style.QuestionTitle}>
                        {question}
                    </Flex>
                </Flex>
                <Flex h='100%'
                className={style.FeedbackStats}
                column shrink={0}
                center>
                <Flex center height='30px' shrink={0}>
                    {posIcon} <Flex className={style.FeedbackStatsText}>{nbrPositive}</Flex>
                </Flex>
                <Flex center height='30px' shrink={0}>
                    {negIcon} <Flex className={style.FeedbackStatsText}>{nbrNegative}</Flex>
                </Flex>
                </Flex>
                {this._renderHover()}

            </Flex>
        )
    }
}

export default QuestionItem;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Questions/QuestionItem/index.js